import { DELETE_STAFF, FETCH_STAFF } from "../actions/actionTypes";

var initialState = [];

const findIndex = (data, PNL_NO) => {
  var result = -1;
  data.forEach((customer, index) => {
    if (customer.PNL_NO === PNL_NO) {
      result = index;
    }
  });
  return result;
};

const staffs = (state = initialState, action) => {
    var index = -1;
  switch (action.type) {
    case FETCH_STAFF:
      state = action.staff;
      return [...state];
    case DELETE_STAFF:
      index = findIndex(state, action.PNL_NO);
      state.splice(index, 1);
      return [...state];
    default:
      return state;
  }
};

export default staffs;
